// InvoiceItem.js - Updated to pass itemId correctly
import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import { BiTrash } from "react-icons/bi";
import EditableField from './EditableField';
import { useTranslation } from 'react-i18next';

const InvoiceItem = (props) => {
  const { onItemizedItemEdit, currency, onRowDel, items, onRowAdd } = props;
  const { t } = useTranslation();

  const itemTable = items.map((item, index) => (
    <ItemRow
      key={item.id}
      item={item}
      index={index}
      onItemizedItemEdit={onItemizedItemEdit}
      onDelEvent={onRowDel}
      currency={currency}
    />
  ));

  return (
    <div>
      <Table style={{ width: '100%' }}>  
        <thead>
          <tr>
            <th>{t('descriptionHeaderTable')}</th>
            <th>{t('priceHeaderTable')}</th>
            <th>{t('qtyHeaderTable')}</th>
            <th className="text-center">{t('amountHeaderTable')}</th>
            <th className="text-center"></th>  
          </tr>
        </thead>
        <tbody>
          {itemTable}
        </tbody>
      </Table>
      <Button className="fw-bold" onClick={onRowAdd}>{t('addItem')}</Button>
    </div>
  );
};

const ItemRow = (props) => {
  const { item, index, onItemizedItemEdit, onDelEvent, currency } = props;
  const { t } = useTranslation();
  const itemDescriptionPlaceholder = t('itemDescriptionPlaceholder');

  const handleDelEvent = () => {
    onDelEvent(item);
  };

  const generateId = (name) => `${item.id || index}-${name}`;

  return (
    <tr>
      <td style={{ width: '100%' }}>
        <EditableField
          onItemizedItemEdit={onItemizedItemEdit}
          itemId={item.id}  // Pass the item ID
          cellData={{
            type: "text",
            name: "description",
            placeholder: itemDescriptionPlaceholder,
            value: item.description,
            id: generateId("description"),
          }}
        />
      </td>
      <td style={{ minWidth: '150px' }}>
        <EditableField
          onItemizedItemEdit={onItemizedItemEdit}
          itemId={item.id}  // Pass the item ID
          cellData={{
            leading: currency,
            type: "number",
            name: "price",
            min: 1,
            step: "0.01",
            precision: 2,
            textAlign: "text-end",
            value: item.price,
            id: generateId("price"),
          }}
        />
      </td>
      <td style={{ minWidth: '80px' }}>
        <EditableField
          onItemizedItemEdit={onItemizedItemEdit}
          itemId={item.id}  // Pass the item ID
          cellData={{
            type: "number",
            name: "quantity",
            min: 1,
            step: "1",
            value: item.quantity,
            id: generateId("quantity"),
          }}
        />
      </td>
      <td className="text-center align-middle py-2" style={{ minWidth: '100px', minHeight: '60px' }}>
        {currency} {item.price * item.quantity}  
      </td>
      <td className="text-center" style={{ minWidth: '25px' }}>
        {index !== 0 && (
          <BiTrash
            onClick={handleDelEvent}
            style={{ height: '30px', width: '30px', padding: '6.5px', cursor: 'pointer' }}
            className="text-danger mt-1 ml-2"  
          />
        )}
      </td>
    </tr>
  );
};

export default InvoiceItem;